import { useEffect, useState } from "react";
import { Category, Products } from "../../pages/home";
import axios from "axios";

import { useDisclosure } from "@mantine/hooks";
import { Modal } from "@mantine/core";

const Items = ({
  category,
  data,
}: {
  category: Category[] | null;
  data: Products[] | null;
}) => {
  const [categoryId, setCategoryId] = useState(1);
  const [product, setProduct] = useState<Products[] | null>(data);
  const [opened, { open, close }] = useDisclosure(false);
  const [image, setImage] = useState("");

  useEffect(() => {
    axios
      .get(`/api/product?categoryId=${categoryId}`)
      .then((res) => {
        if (res.data.code === "0000") {
          setProduct(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, [categoryId]);

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        title="카이노스 제품소개"
        centered
        size={"lg"}
      >
        <img
          src={image}
          alt="카이노스 바이오케미칼 제품 상세 이미지"
          className=" relative w-full h-full object-contain mx-auto"
        />
      </Modal>

      <div
        id="item"
        className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
      >
        <div
          id="title"
          className="relative w-full h-fit text-center mb-10 xl:mb-14"
        >
          <h3 className="font-normal">제품소개</h3>
          <p className="text-primary my-5 lg:text-lg">
            - Introduction of item -
          </p>
          <p className=" lg:text-lg">
            오염을&nbsp;근원적으로&nbsp;제거하여&nbsp;90%이상
            원래&nbsp;상태로&nbsp;복원&nbsp;및&nbsp;지속{" "}
            <br className="hidden lg:block" />
            불산,&nbsp;염산,&nbsp;가성소다&nbsp;등
            환경피해가&nbsp;우려되는&nbsp;맹독성&nbsp;세제가 아닌
            식품첨가물&nbsp;친환경세정제
          </p>
        </div>
        <div className=" relative w-full h-fit grid lg:grid-cols-3 max-w-screen-lg mx-auto text-center mb-10 xl:mb-14">
          {category &&
            category.map((v, i) => (
              <div
                key={i}
                onClick={() => setCategoryId(v.id)}
                className={
                  v.id === categoryId
                    ? "relative w-full h-full bg-primary border border-primary text-white cursor-pointer"
                    : "relative w-full h-full text-primary border border-primary bg-transparent cursor-pointer"
                }
              >
                <p className="text-lg pt-1 pb-0.5">{v.name}</p>
              </div>
            ))}
        </div>
        <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 lg:grid-cols-4 gap-5 lg:gap-6">
          {product &&
            product.map((v, i) => (
              <div
                key={i}
                data-aos="fade-up"
                onClick={() => {
                  setImage(v.src);
                  open();
                }}
                className="relative w-full h-full"
              >
                <div className="relative w-full h-72 xl:h-80 overflow-hidden">
                  <img
                    className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                    alt={`카이노스 바이오케미칼 ${(v.title || "").replace(/<[^>]*>/g, "")} 제품`}
                    src={v.src}
                    width={414}
                    height={506}
                  />
                </div>
                <div className=" relative w-full h-fit text-center bg-primary text-white">
                  <p
                    className="py-2 xl:text-xl"
                    dangerouslySetInnerHTML={{ __html: v.title }}
                  ></p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Items;
